import './single_dimension_view_base_factory.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.HierarchicalDimensionViewFactory extends CustomerVisualMode.Charts.SingleDimensionViewBaseFactory

  canHandle: (widget) ->
    widget.get('dimension') == Common.WidgetDimensions.HIERARCHICAL_ATTRIBUTE

  create: (widget, data, isReadOnly, isResponsive) ->
    dataTranslator = @_nameTranslator(widget)
    dataFormatter = new CustomerVisualMode.Charts.HierarchicalAttributeDataFormatter(dataTranslator)
    chartView = @_chartToRender(widget, dataFormatter, data)
    new CustomerVisualMode.Charts.HierarchicalDimensionView({
      widget: widget,
      data: data,
      session: @session,
      isReadOnly: isReadOnly,
      isResponsive: isResponsive,
      barMenu: @barMenuViewFactory.create(widget, data),
      sortDropdown: @_createSortDropdown(widget),
      dataTranslator: dataTranslator,
      dataFormatter: dataFormatter,
      chartView: chartView
    })
